import * as React from 'react';
import {Field, reduxForm, InjectedFormProps, formValueSelector} from 'redux-form';
import {
    RenderField,
    CarIdsSelect,
    Validators,
    PrioritySelect,
    SelectField,
    BooleanIcon,
    FleetIdsSelect,
    DomainOfIntrestSelect
} from './Fields/_Fields';
import {withTranslation} from 'react-i18next';
import * as VehiclesModule from 'Modules/VehiclesModule';
import {connect} from 'react-redux';
import * as Dictionary from 'Models/Dictionary';
import {ErrorStore} from 'Redux/Actions/Models/ErrorActionModel';
import {compose} from 'redux';

type ConnectedProps = {
    t: Function;
};

type Props = {
    onCancel: Function;
    onCarDelete: Function;
    onFleetDelete: Function;
    onDomainDelete: Function;
    deleteAlert: Function;
    alertCondition: {
        label: string;
        value: string;
    };
    redirect: Function;
    initialCars: Array<VehiclesModule.Types.CarDto>;
    errorStore: ErrorStore;
    showVehicleList: () => Function;
    showFleetList: () => Function;
    showZonesList: () => Function;
};

const AddAlert = (props: InjectedFormProps & ConnectedProps & Props) => {
    const {
        onDomainDelete,
        handleSubmit,
        t,
        initialCars,
        onCarDelete,
        showVehicleList,
        onFleetDelete,
        alertCondition,
        showFleetList,
        showZonesList
    } = props;
    const alertConditionOptions = Dictionary.GenerateList(Dictionary.AlertConditionArray, 'carDetails');
    const priorityOptions = Dictionary.GenerateList(Dictionary.PriorityArray, 'carDetails');
    return (
        <form className="form form--flex main__bottom-space" onSubmit={handleSubmit}>
            <div className="form__col--ratio-1 mr-20">
                <Field name="priority" component={PrioritySelect} options={priorityOptions} type="text"
                       placeholder={t('priority')} label={t('priority')} validate={[Validators.required]}/>
                <Field name="name" component={RenderField} type="text" placeholder={t('alertName')}
                       label={t('alertName')} validate={[Validators.required]}/>
                <Field
                    name="alertCondition"
                    component={SelectField}
                    options={alertConditionOptions}
                    type="text"
                    placeholder={t('alertCondition')}
                    label={t('alertCondition')}
                    validate={[Validators.required]}
                />
                <Field
                    disabled={alertCondition && alertCondition.value !== 'SPEEDING'}
                    name="conditionValue"
                    component={RenderField}
                    type="text"
                    placeholder={t('conditionValue')}
                    label={t('conditionValue')}
                    validate={alertCondition && alertCondition.value === 'SPEEDING' ? [Validators.required, Validators.number, Validators.greaterThanZero] : []}
                />
                <Field name="message" component={RenderField} type="text" placeholder={t('message')}
                       label={t('message')} validate={[Validators.required]}/>

                <div className="form-field">
                    <label className="form-field__label">{t('alertNotifyType')}</label>
                    <div className="flex">
                        <Field name="notifyByEmail" component={BooleanIcon} iconSrc={'/images/icons/at.svg'} type="text"
                               placeholder={t('notifyByEmail')} label={t('notifyByEmail')}/>
                        <Field
                            name="notifyBySystemNotification"
                            iconSrc={'/images/icons/alert-bell.svg'}
                            component={BooleanIcon}
                            type="text"
                            placeholder={t('notifyBySystemNotification')}
                            label={t('notifyBySystemNotification')}
                        />
                    </div>
                </div>
            </div>
            <div className="form__col--ratio-1-5 mr-20">
                <Field
                    onDelete={onCarDelete}
                    name="carIds"
                    component={CarIdsSelect}
                    type="text"
                    placeholder={t('assignedCars')}
                    label={`${t('assignedCars')} ${initialCars ? initialCars.length : ''}`}
                    validate={[Validators.required]}
                    showList={showVehicleList}
                />
                <Field
                    onDelete={onFleetDelete}
                    name="fleetIds"
                    component={FleetIdsSelect}
                    type="text"
                    placeholder={t('assignedFleets')}
                    label={`${t('assignedFleets')} ${initialCars ? initialCars.length : ''}`}
                    validate={[Validators.required]}
                    showList={showFleetList}
                />
            </div>
            <div className="form__col--ratio-1-5 mr-20">
                <Field
                    onDelete={onDomainDelete}
                    name="domainIds"
                    component={DomainOfIntrestSelect}
                    type="text"
                    placeholder={t('assignedDomains')}
                    label={`${t('assignedDomains')} ${initialCars ? initialCars.length : ''}`}
                    validate={[Validators.required]}
                    showList={showZonesList}
                />
            </div>
        </form>
    )
        ;
};

const mapStateToProps = (state: any) => {
    const selector = formValueSelector('AddAlert');
    const alertCondition = selector(state, 'alertCondition');
    return {
        alertCondition,
        errorStore: state.errorStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation(['forms', 'errors', 'carDetails']),
    reduxForm({
        form: 'AddAlert',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(AddAlert) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddAlert.tsx